import React, { Component } from "react";
import commStyles from "../../common/styles";
import { connect } from "react-redux";
import { Container } from "../../common/components/Container";
import { Table } from "../../common/components/Table";
import { Model } from "../../common/components/Model";
import { ReactSelect } from "../../common/components/ReactSelect";
import apiCall from "../../common/utils/apiCall";
import AddCardIcon from "@mui/icons-material/AddCard";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "../../common/styles/styles.css";

const {
  Form,
  FormColumn,
  FormRow,
  FormInput,
  FormInputLabel,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  IconWhiteHover,
} = commStyles;

const columns = [
  { id: "homeConfigName", label: "HomeConfig Name", minWidth: "10%" },
  { id: "label", label: "Info", minWidth: "10%" },
  { id: "settingActions", label: "Actions", minWidth: "10%" },
];
const imageColumns = [
  { id: "imageName", label: "Image Name", minWidth: "10%" },
  { id: "imageUrl", label: "Image Url", minWidth: "10%" },
  { id: "operationDelete", label: "Delete", minWidth: "10%" },
];
const categoryColumns = [
  { id: "categoryName", label: "Category Name", minWidth: "10%" },
  { id: "imageUrl", label: "Image Url", minWidth: "10%" },
  { id: "operationDelete", label: "Delete", minWidth: "10%" },
];
const bestOfferColumns = [
  { id: "number", label: "Number", minWidth: "10%" },
  { id: "operationDelete", label: "Delete", minWidth: "10%" },
];
const numberColumns = [
  { id: "number", label: "Number", minWidth: "10%" },
  { id: "operationDelete", label: "Delete", minWidth: "10%" },
];

let mountLimit = 1;
let filterHeight = document.getElementById("filterDiv")
  ? `${document.getElementById("filterDiv").offsetHeight}px`
  : "10vh";

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homeConfigData: [],
      jsonArray: [],
      homeConfigId: "",
      totalSize: 0,
      rowsPerPage: 20,
      filterOptionsLimit: 20,
      imageModelOpen: false,
      categoryModalopen: false,
      categoryFilterInput: "",
      categoryFilterOptions: [],
      categoryFilterLoading: false,
      numberModelOpen: false,
      bestOfferModelOpen: false,
      todayOfferModelOpen: false,
      numbersFilterInput: "",
      numbersFilterLoading: false,
      numbersFilterOptions: [],
      createData: {},
      filterData: {},
    };
  }

  async componentDidMount() {
    if (mountLimit === 1) {
      mountLimit++;
      try {
        const { result } = await apiCall("REACT_APP_GET_HOME_CONFIG", "POST", {
          limit: this.state.rowsPerPage,
          skip: 0,
        });

        if (result?.success && result.status) {
          let modifyData = await this.modifyApiData(result.status);
          this.setState({
            homeConfigData: modifyData,
            totalSize: result.totalSize,
          });
          toast.success(result.msg);

          // Create any missing configs
          const existingNames = result.status.map((cfg) => cfg.homeConfigName);
          const requiredConfigs = [
            { name: "New Arrivals", type: "number" },
            { name: "headerImages", type: "image" },
            { name: "Best Offer", type: "bestOffer" },
            { name: "Todays Offer", type: "todaysOffer" },
            { name: "Category Section", type: "category" },
          ];

          for (const config of requiredConfigs) {
            if (!existingNames.includes(config.name)) {
              await apiCall("REACT_APP_CREATE_HOME_CONFIG", "POST", {
                homeConfigName: config.name,
                type: config.type,
                jsonArray: [],
              });
            }
          }
        } else {
          toast.error("Failed to fetch home config.");
        }
      } catch (error) {
        console.error("Category componentDidMount Error ::", error);
      } finally {
        setTimeout(() => {
          mountLimit--;
        }, 500);
      }
    }
  }

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map((data) => {
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();
      data["settingActions"] = data.jsonArray;
      
      // Add descriptive label based on type
      switch(data.type) {
        case "category":
          data.label = "Add category to home page.";
          break;
        case "image":
          data.label = "Add images to home page.";
          break;
        case "number":
          data.label = "Add numbers to home page.";
          break;
        case "bestOffer":
          data.label = "Add best offers to home page.";
          break;
        case "todaysOffer":
          data.label = "Add today's offers to home page.";
          break;
        default:
          data.label = "Add " + data.type + " to home page.";
      }
      
      return data;
    });
  }

  handleCategoryInputChange = async (categoryFilterInput, { action }) => {
    this.setState({ categoryFilterLoading: true });
    let input;
    let categoryFilterOptions = [];
    if (action === "set-value") {
      input = this.state.categoryFilterInput;
    } else {
      input = categoryFilterInput;
      this.setState({ categoryFilterInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_CATEGORY", "POST", {
        textToSearch: input,
        limit: 10,
      });
      if (result && result.success) {
        categoryFilterOptions = await this.formatData(
          result.status,
          "id",
          "categoryName"
        );
      }
    }

    this.setState(
      { categoryFilterOptions, categoryFilterLoading: false },
      () => {
        console.log(
          "Category Filter Options:",
          this.state.categoryFilterOptions
        );
      }
    );
  };

  handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // Create FormData
      const formData = new FormData();
      formData.append("image", file);

      // Call your backend endpoint to handle the upload
      const response = await apiCall(
        "REACT_APP_UPLOAD_IMAGE",
        "POST",
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      );

      if (response.success && response.imageUrl) {
        this.setState((prevState) => ({
          createData: {
            ...prevState.createData,
            imageUrl: response.imageUrl, // CDN URL from backend
          },
        }));
        toast.success("Image uploaded successfully!");
      } else {
        toast.error("Upload failed. Please try again.");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Error uploading image");
    }
  };

  settingActionsClick = async (data) => {
    try {
      let jsonArray = JSON.parse(data.jsonArray);
      if (Array.isArray(jsonArray)) {
        this.setState({ jsonArray, homeConfigId: data.id });
        if (data.type == "image") {
          this.setState({ imageModelOpen: true });
        } else if (data.type == "number") {
          this.setState({ numberModelOpen: true });
        } else if (data.type == "bestOffer") {
          this.setState({ bestOfferModelOpen: true });
        } else if (data.type == "todaysOffer") {
          this.setState({ todayOfferModelOpen: true });
        } else if (data.type == "category") {
          this.setState({ categoryModalopen: true });
        }
      }
    } catch (error) {}
  };
  addOneImageHomeConfig = (event) => {
    let jsonArray = this.state.jsonArray;
    let data = this.state.createData;
    if (data.imageName.length < 3) {
      toast.error("imageName must be gratorThan or equalTo 3");
    } else if (
      !data.imageUrl.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      )
    ) {
      toast.error("imageUrl is not a valid url");
    } else {
      jsonArray.unshift(data);
      this.setState({
        jsonArray,
        createData: { imageName: "", imageUrl: "" },
      });
    }
  };

  addOneCategoryHomeConfig = () => {
    const jsonArray = [...this.state.jsonArray];
    const selectedCategoryId = this.state.createData.id;
    const selectedCategories = this.state.createData.categoryName;
    const imageUrl = encodeURI(this.state.createData.imageUrl);
    console.log("data:", this.state.createData);
    console.log("selectedCategories:", selectedCategories);
    console.log("selectedCategoryId:", selectedCategoryId);
    if (!selectedCategories || selectedCategories.trim() === "") {
      toast.error("Please select at least one category.");
      return;
    }

    if (
      !imageUrl.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      )
    ) {
      toast.error("Image URL is not valid.");
      return;
    }

    // Create new config entry
    const newEntry = {
      categoryName: selectedCategories,
      imageUrl,
      categoryId: selectedCategoryId,
    };

    jsonArray.unshift(newEntry);

    this.setState({
      jsonArray,
      createData: {
        categoryName: "",
        imageUrl: "",
      },
    });
  };

  deleteOneCategoryHomeConfig = (data) => {
    let jsonArray = [...this.state.jsonArray];

    const getIndex = jsonArray.findIndex(
      (entry) =>
        JSON.stringify(entry.categoryName) ===
          JSON.stringify(data.categoryName) && entry.imageUrl === data.imageUrl
    );

    if (getIndex !== -1) {
      jsonArray.splice(getIndex, 1);
      this.setState({ jsonArray });
    }
  };

  addMultiHomeConfig = (event) => {
    let jsonArray = this.state.jsonArray;
    let data = this.state.filterData;
    if (data.number.length == 0) {
      toast.error("select  atleast one number");
    } else {
      data.number.forEach((number) => {
        jsonArray.unshift({ number });
      });
      this.setState({
        jsonArray,
        filterData: { number: [] },
      });
    }
  };
  deleteOneImageHomeConfig = (data) => {
    if (Object.keys(data)[0] == "number") {
      let jsonArray = this.state.jsonArray;
      let getIndex = jsonArray.findIndex((e) => e.number === data.number);
      jsonArray.splice(getIndex, 1);
      this.setState({
        jsonArray,
      });
    } else {
      let jsonArray = this.state.jsonArray;
      let getIndex = jsonArray.findIndex(
        (e) => e.imageName === data.imageName && e.imageUrl === data.imageUrl
      );
      jsonArray.splice(getIndex, 1);
      this.setState({
        jsonArray,
      });
    }
  };
  submitHomePageConfig = async (data) => {
    const { result } = await apiCall("REACT_APP_UPDATE_HOME_CONFIG", "POST", {
      homeConfigId: this.state.homeConfigId,
      jsonArray: this.state.jsonArray,
    });
    if (result && result.success) {
      this.setState({ imageModelOpen: false });
      this.setState({ numberModelOpen: false });
      this.setState({ bestOfferModelOpen: false });
      this.setState({ todayOfferModelOpen: false });
      this.setState({ categoryModalopen: false });
      this.componentDidMount();
      toast.success(result.msg);
    }
  };
  handleChange = (event, state, stateEdit, stateCreate) => {
    // If no value is selected
    if (!event) {
      if (stateEdit) {
        this.setState((prevState) => ({
          editData: {
            ...prevState.editData,
            [stateEdit]: "",
          },
        }));
      } else if (stateCreate) {
        this.setState((prevState) => ({
          createData: {
            ...prevState.createData,
            [stateCreate]: "",
          },
        }));
      } else {
        this.setState((prevState) => ({
          filterData: {
            ...prevState.filterData,
            [state]: [],
          },
        }));
      }
      return;
    }

    // For stateEdit (single select)
    if (stateEdit) {
      this.setState((prevState) => ({
        editData: {
          ...prevState.editData,
          [stateEdit]: event.value,
        },
      }));
    }
    // For stateCreate (single select)
    else if (stateCreate) {
      this.setState((prevState) => ({
        createData: {
          ...prevState.createData,
          [stateCreate]: event.label,
          id: event.value || "", // Ensure id is set if available
        },
      }));
    }
    // For filters (multi select still allowed here)
    else {
      this.setState((prevState) => ({
        filterData: {
          ...prevState.filterData,
          [state]: Array.isArray(event)
            ? event.map((data) =>
                state === "number" ? data.label : data.value
              )
            : [event.value],
        },
      }));
    }
  };

  formatData = async (data, value, label) => {
    return await data.map((eachData) => {
      let obj = {};
      obj["value"] = eachData[value];
      obj["label"] = eachData[label];
      return obj;
    });
  };
  handleNumbersInputChange = async (numbersFilterInput, { action }) => {
    this.setState({ numbersFilterLoading: true });
    let input;
    let numbersFilterOptions = [];
    if (action === "set-value") {
      input = this.state.numbersFilterInput;
    } else {
      input = numbersFilterInput;
      this.setState({ numbersFilterInput });
    }
    if (input.split("").length >= 0) {
      const { result } = await apiCall("REACT_APP_GET_NUMBERS", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
        status: [2],
      });
      if (result && result.success) {
        numbersFilterOptions = await this.formatData(
          result.status,
          "id",
          "number"
        );
      }
    }

    this.setState({ numbersFilterOptions, numbersFilterLoading: false });
  };
  submitFilter = async (filterData) => {
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = 0;
    filterData["limit"] = this.state.rowsPerPage || 20;
    const { result } = await apiCall(
      "REACT_APP_GET_CATEGORY",
      "POST",
      filterData
    );
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        categoryData: modifyData,
        totalSize: await result.totalSize,
      });
      toast.success(result.msg);
    }
  };
  submitDeleteForm = async (deleteData) => {
    Object.keys(deleteData).forEach((data) => {
      if (
        deleteData[data] == [] ||
        deleteData[data] == {} ||
        deleteData[data] == ""
      ) {
        delete deleteData[data];
      }
    });
    if (Object.keys(deleteData).length == 0) {
      return;
    }
    const { result } = await apiCall(
      "REACT_APP_DELETE_CATEGORY",
      "POST",
      deleteData
    );
    if (result && result["success"] && result["status"]) {
      this.setState({ deleteModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };
  submitCreateForm = async (createData) => {
    Object.keys(createData).forEach((data) => {
      if (
        createData[data] == [] ||
        createData[data] == {} ||
        createData[data] == ""
      ) {
        delete createData[data];
      }
    });
    if (Object.keys(createData).length == 0) {
      return;
    }
    const { result } = await apiCall(
      "REACT_APP_CREATE_CATEGORY",
      "POST",
      createData
    );
    if (result && result["success"] && result["status"]) {
      this.setState({ createModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };
  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = chnagedPage * rowsPerPage || 0;
    filterData["limit"] = rowsPerPage || 20;
    for (let i = 0; i < filterData["skip"]; i++) {
      skippedEmptyArrayOfObj.push({});
    }
    const { result } = await apiCall(
      "REACT_APP_GET_CATEGORY",
      "POST",
      filterData
    );
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        categoryData: [...skippedEmptyArrayOfObj, ...modifyData],
        rowsPerPage: rowsPerPage,
        totalSize: await result.totalSize,
      });
      return true;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <Container headerName="Home Config Manager" navPosition="5">
          <div
            id="filterDiv"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: filterHeight,
              border: "none",
              overflow: "none",
            }}
          >
            {/* <div id="filterSelectDiv">
              <ReactSelect
                label = {'Numbers Category'}
                placeholder = {'Search Category'}
                inputValue = {this.state.categoryFilterInput}
                onInputChange = {this.handleCategoryInputChange}
                options = {this.state.categoryFilterOptions}
                stateFilterName = {'id'}
                onChange = {this.handleChange}
                isLoading = {this.state.categoryFilterLoading}
                isMulti = {true}
              />
            </div>
            <div style={{
              display : 'flex',
              flexDirection : 'row',
              gap : '10px',
              alignItems : 'center',
              justifyContent : 'center',
            }}>
              <ButtonSuccess
                style={{
                  display : 'flex',
                  flexDirection : 'row',
                  gap : '5px',
                  alignItems : 'center',
                  height : '28px',
                  padding : '7px 10px'
                }}
                onClick={()=>{this.submitFilter(this.state.filterData)}}
              >
                <span id="filterButtonStyle">FILTER</span>
                <FilterAltIcon sx={{width : '15px'}}/>
              </ButtonSuccess>
              <ButtonSuccess
                style={{
                  display : 'flex',
                  flexDirection : 'row',
                  gap : '5px',
                  alignItems : 'center',
                  height : '28px',
                  padding : '7px 10px'
                }}
                onClick={()=>{this.setState({createModelOpen:true})}}
              >
                <span id="filterButtonStyle">CREATE</span>
                <AddCircleIcon sx={{width : '15px'}}/>
              </ButtonSuccess>
            </div> */}
          </div>
          <Table
            columns={columns || []}
            dataValues={this.state.homeConfigData || []}
            totalSize={this.state.totalSize || 0}
            filterHeight={filterHeight}
            rowsPerPage={this.state.rowsPerPage}
            handleChangePage={this.handleChangePage}
            settingActionsClick={this.settingActionsClick}
          />
        </Container>

        {/* IMAGE MODEL */}
        <Model
          title={"Home Image Config"}
          modelOpen={this.state.imageModelOpen}
        >
          <Form>
            <FormRow>
              <FormInput
                type="text"
                required={true}
                target
                value={this.state.createData["imageName"]}
                placeholder="ImageName"
                onChange={(e) => {
                  this.handleChange(e.target, "", "", "imageName");
                }}
              ></FormInput>
              <FormInput
                type="text"
                required={true}
                value={this.state.createData["imageUrl"]}
                placeholder="Image Url"
                onChange={(e) => {
                  this.handleChange(e.target, "", "", "imageUrl");
                }}
              ></FormInput>
              <IconWhiteHover
                onClick={(e) => {
                  this.addOneImageHomeConfig(e);
                }}
              >
                <AddCardIcon />
              </IconWhiteHover>
            </FormRow>
            <Table
              maxHeight={"400px"}
              columns={imageColumns || []}
              dataValues={this.state.jsonArray || []}
              totalSize={this.state.jsonArray.length || 0}
              // filterHeight = {filterHeight}
              // rowsPerPage = {this.state.rowsPerPage}
              // handleChangePage = {this.handleChangePage}
              // editModel={this.editModel}
              // openAddress={this.openAddress}
              deleteEntry={this.deleteOneImageHomeConfig}
            />
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ imageModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitHomePageConfig(this.state.jsonArray);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>
        {/* Cateory MODEL */}
        <Model
          title={"Home Category Section Config"}
          modelOpen={this.state.categoryModalopen}
        >
          <Form>
            <FormRow style={{ marginBottom: "20px" }}>
              <ReactSelect
                label={"Category"}
                placeholder={"Search Category"}
                inputValue={this.state.categoryFilterInput}
                onInputChange={this.handleCategoryInputChange}
                options={this.state.categoryFilterOptions}
                stateFilterName={"categoryName"}
                onChange={(selected) =>
                  this.handleChange(selected, "", "", "categoryName")
                }
                isMulti={false}
              />
              <input
                type="file"
                accept="image/*"
                onChange={this.handleImageUpload}
              />
              {this.state.createData["imageUrl"] && (
                <img
                  src={this.state.createData["imageUrl"]}
                  alt="Preview"
                  style={{ height: "100px", marginTop: "10px" }}
                />
              )}
              <IconWhiteHover
                onClick={(e) => {
                  this.addOneCategoryHomeConfig(e);
                }}
              >
                <AddCardIcon />
              </IconWhiteHover>
            </FormRow>
            <Table
              maxHeight={"400px"}
              columns={categoryColumns || []}
              dataValues={this.state.jsonArray || []}
              totalSize={this.state.jsonArray.length || 0}
              // filterHeight = {filterHeight}
              // rowsPerPage = {this.state.rowsPerPage}
              // handleChangePage = {this.handleChangePage}
              // editModel={this.editModel}
              // openAddress={this.openAddress}
              deleteEntry={this.deleteOneCategoryHomeConfig}
            />
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ categoryModalopen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitHomePageConfig(this.state.jsonArray);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* BEST OFFER MODEL */}
        <Model
          title={"Home Best Offer Config"}
          modelOpen={this.state.bestOfferModelOpen}
        >
          <Form>
            <FormRow style={{ marginBottom: "20px" }}>
              <ReactSelect
                label={"Best Offer"}
                placeholder={"Select Number"}
                inputValue={this.state.numbersFilterInput}
                onInputChange={this.handleNumbersInputChange}
                options={this.state.numbersFilterOptions}
                stateFilterName={"number"}
                onChange={this.handleChange}
                isLoading={this.state.numbersFilterLoading}
                isMulti={false}
              />
              <IconWhiteHover
                onClick={(e) => {
                  this.addMultiHomeConfig(e);
                }}
              >
                <AddCardIcon />
              </IconWhiteHover>
            </FormRow>
            <Table
              maxHeight={"400px"}
              columns={bestOfferColumns || []}
              dataValues={this.state.jsonArray || []}
              totalSize={this.state.jsonArray.length || 0}
              // filterHeight = {filterHeight}
              // rowsPerPage = {this.state.rowsPerPage}
              // handleChangePage = {this.handleChangePage}
              // editModel={this.editModel}
              // openAddress={this.openAddress}
              deleteEntry={this.deleteOneImageHomeConfig}
            />
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ bestOfferModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitHomePageConfig(this.state.jsonArray);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* NUMBER MODEL */}
        <Model
          title={"Home Numbers Config"}
          modelOpen={this.state.numberModelOpen}
        >
          <Form>
            <FormRow style={{ marginBottom: "20px" }}>
              <ReactSelect
                label={"Numbers"}
                placeholder={"Select Numbers"}
                inputValue={this.state.numbersFilterInput}
                onInputChange={this.handleNumbersInputChange}
                options={this.state.numbersFilterOptions}
                stateFilterName={"number"}
                onChange={this.handleChange}
                isLoading={this.state.numbersFilterLoading}
                isMulti={true}
              />
              <IconWhiteHover
                onClick={(e) => {
                  this.addMultiHomeConfig(e);
                }}
              >
                <AddCardIcon />
              </IconWhiteHover>
            </FormRow>
            <Table
              maxHeight={"400px"}
              columns={numberColumns || []}
              dataValues={this.state.jsonArray || []}
              totalSize={this.state.jsonArray.length || 0}
              // filterHeight = {filterHeight}
              // rowsPerPage = {this.state.rowsPerPage}
              // handleChangePage = {this.handleChangePage}
              // editModel={this.editModel}
              // openAddress={this.openAddress}
              deleteEntry={this.deleteOneImageHomeConfig}
              stopPleaseWait={true}
            />
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ numberModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitHomePageConfig(this.state.jsonArray);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* TODAY OFFER MODEL */}

        <Model
          title={"Home Today's Offer Config"}
          modelOpen={this.state.todayOfferModelOpen}
        >
          <Form>
            <FormRow style={{ marginBottom: "20px" }}>
              <ReactSelect
                label={"Numbers"}
                placeholder={"Select Numbers"}
                inputValue={this.state.numbersFilterInput}
                onInputChange={this.handleNumbersInputChange}
                options={this.state.numbersFilterOptions}
                stateFilterName={"number"}
                onChange={this.handleChange}
                isLoading={this.state.numbersFilterLoading}
                isMulti={true}
              />
              <IconWhiteHover
                onClick={(e) => {
                  this.addMultiHomeConfig(e);
                }}
              >
                <AddCardIcon />
              </IconWhiteHover>
            </FormRow>
            <Table
              maxHeight={"400px"}
              columns={numberColumns || []}
              dataValues={this.state.jsonArray || []}
              totalSize={this.state.jsonArray.length || 0}
              // filterHeight = {filterHeight}
              // rowsPerPage = {this.state.rowsPerPage}
              // handleChangePage = {this.handleChangePage}
              // editModel={this.editModel}
              // openAddress={this.openAddress}
              deleteEntry={this.deleteOneImageHomeConfig}
              stopPleaseWait={true}
            />
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ todayOfferModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/homeConfig"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitHomePageConfig(this.state.jsonArray);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Category);
